import * as React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';

import { useStateTablePage } from '../../../common/component/hooks/useStateTablePage';

import { CarUseResultInfoType } from '../../feature/type/CarUseResultInfoType';
import { tableColumnList } from '../../const/carUseResultPageConst';
import { table, tableBox } from '../../const/carUseResultPageSize';

import theme from '../../../theme';

type Props = {
	carUseResultList: CarUseResultInfoType[] | [];
};

/**
 * 車両利用実績一覧テーブル
 */
export const CarUseResultTable = (props: Props) => {
	const { carUseResultList } = props;

	const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, handleTableRowClick, isRowSelected } = useStateTablePage(carUseResultList); // テーブルページの状態管理用カスタムフック

	return (
		<Paper sx={{ height: tableBox.height, width: tableBox.width, overflow: 'hidden' }}>
			<TableContainer sx={{ maxHeight: table.height, minHeight: table.height }}>
				<Table stickyHeader size="small" aria-label="carUseResultTable">
					<TableHead>
						<TableRow>
							{tableColumnList.map((tableColumn, index) => (
								<TableCell
									key={index}
									style={{
										minWidth: tableColumn.minWidth,
										fontSize: 15,
										color: theme.palette.common.black,
										backgroundColor: '#d3d3d3',
										fontWeight: 'bold',
									}}
								>
									{tableColumn.label}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody id="carUseResultTableBody">
						{carUseResultList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
							return (
								<TableRow
									hover
									role="checkbox"
									tabIndex={-1}
									key={index}
									onClick={() => {
										handleTableRowClick(index);
									}}
									selected={isRowSelected(index)}
									aria-checked={isRowSelected(index)}
								>
									<TableCell key="startDatetime">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.startDatetime}</Typography>}
									</TableCell>
									<TableCell key="endDatetime">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.endDatetime}</Typography>}
									</TableCell>
									<TableCell key="organizationName">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.organizationName}</Typography>}
									</TableCell>
									<TableCell key="carCode">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.carCode}</Typography>}
									</TableCell>
									<TableCell key="numberPlate">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.numberPlate}</Typography>}
									</TableCell>
									<TableCell key="driverName">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.driverName}</Typography>}
									</TableCell>
									<TableCell key="model">{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.model}</Typography>}</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePagination
				rowsPerPageOptions={[20, 40]}
				component="div"
				count={carUseResultList.length}
				rowsPerPage={rowsPerPage}
				page={carUseResultList.length ? page : 0}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
			/>
		</Paper>
	);
};
